module.exports = __webpack_public_path__ + "img/payment_portal.27aa1f56.jpg";